import i18n from '../i18nService';
import { preferencesGroupsStorage } from './preferencesGroupsStorage';

const resolveGroup = (groupOrCode) => {
    if (groupOrCode && typeof groupOrCode === 'object') {
        const fromStorage = preferencesGroupsStorage.groupsList.find(
            (it) => it.id === groupOrCode.id || it.name === groupOrCode.name,
        );
        return fromStorage ?? groupOrCode;
    }
    if (typeof groupOrCode === 'string') {
        return preferencesGroupsStorage.groupsList.find((it) => it.name === groupOrCode);
    }
    return null;
};

const getNameFromGroup = (group, localeCode) => {
    if (group?.names?.length) {
        const found = group.names.find((it) => it.locale === localeCode);
        if (found?.name) {
            return found.name;
        }
    }
    return '';
};

export const preferenceGroupNamesService = {
    getLocalization(localeCode, groupOrCode, withCodeReplace = false) {
        const group = resolveGroup(groupOrCode);
        const code = group?.name ?? (typeof groupOrCode === 'string' ? groupOrCode : '');
        const apiName = group ? getNameFromGroup(group, localeCode) : '';
        if (apiName) {
            return apiName;
        }
        return withCodeReplace ? code : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.preference.groupName');
    },
};
